import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, InputAdornment } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import DialogLoading from '../../../../components/feedback/DialogLoading';
import AppButton from '../../../../components/ui/AppButton';
import AppInput from '../../../../components/ui/AppInput';
import { useSendEvaluation } from '../../../../hooks/useEvaluation';
import { useGetUserInfinite } from '../../../../hooks/useUser';
import { useDialogStore } from '../../../../stores/dialogStore';
import LineUserCard from './LineUserCard';

const SendEvaluationTab = () => {
  const openDialog = useDialogStore((state) => state.openDialog);
  const [search, setSearch] = useState('');
  const [submitSearch, setSubmitSearch] = useState('');
  const { mutateAsync: sendEvaluation, isPending: sendEvaluateLoading } = useSendEvaluation();
  const {
    data: listUser,
    fetchNextPage,
    hasNextPage,
  } = useGetUserInfinite({ limit: 20, search: submitSearch || undefined });
  const users = listUser?.pages.flatMap((page) => page?.Data?.data) ?? [];

  const handleSendEvaluation = async (userId) => {
    try {
      const response = await sendEvaluation({ dto: { user_id: userId } });

      if (response.Code === '20100') {
        openDialog({
          title: 'สำเร็จ',
          message: 'ส่งแบบประเมินสำเร็จ',
        });
      }
    } catch (err) {
      console.error(err);
      openDialog({
        title: 'เกิดข้อผิดพลาด',
        message: 'ส่งแบบประเมินไม่สำเร็จ',
        variant: 'error',
      });
    }
  };

  const handleSearchListLineUser = () => {
    setSubmitSearch(search);
  };

  return (
    <Box
      sx={{
        padding: '16px',
        backgroundColor: 'white',
        borderBottomLeftRadius: '15px',
        borderBottomRightRadius: '15px',
        border: '2px solid white',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      }}
    >
      <Box display="flex" alignItems="center" gap={1} mb={2} sx={{ maxWidth: 500, width: '100%' }}>
        <AppInput
          placeholder="ค้นหาชื่อไลน์"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#004B61' }} />
              </InputAdornment>
            ),
          }}
        />
        <AppButton variant="dangerStrong" onClick={handleSearchListLineUser}>
          ค้นหา
        </AppButton>
      </Box>
      <Box id="container" sx={{ width: '100%', height: 'calc(100vh - 400px)', overflow: 'auto' }}>
        <InfiniteScroll
          dataLength={users.length}
          next={fetchNextPage}
          hasMore={!!hasNextPage}
          loader={<Box sx={{ fontSize: '1.25rem', textAlign: 'center' }}>Loading...</Box>}
          scrollableTarget="container"
        >
          {users.map((item) => (
            <Box
              key={item._id}
              sx={{
                padding: '.5rem 0',
                borderBottom: '1px solid #EEE',
                '&:last-child': { borderBottom: 'none' },
              }}
            >
              <LineUserCard
                src={item.pictureUrl || null}
                name={item.displayName || item.lineuserid}
                onClick={() => handleSendEvaluation(item._id)}
              />
            </Box>
          ))}
        </InfiniteScroll>
      </Box>
      <DialogLoading open={sendEvaluateLoading} message="กำลังส่งแบบประเมิน" />
    </Box>
  );
};
export default SendEvaluationTab;
